/**
 * Created by andyosullivan on 20/06/2021.
 */
import React, { Component } from "react";
import "../Home/Home.css";
import "./About.css";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import logo from '../../assets/images/noadsherelogo.jpg';

export default class About extends Component {

    componentDidMount () {
        this.deleteAllCookies();
    }

    deleteAllCookies() {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }

        localStorage.clear()
        sessionStorage.clear();
    }

    render() {
        return (
            <div className="divmor">
                <Container>

                    <Row className="blurbRow">


                        <Col className="" sm={12} lg={8}>
                            <div className="aboutDiv">
                                <h1 className="darkGrey">about</h1>
                                <p className="aboutBlurb"> NOadsHERE.com is a new site created as a counterbalance
                                    to the ad-driven internet. This site has no ads, no user tracking, no user analytics,
                                    no affiliate marketing, no cookies, no cost, no subscriptions, no paywalls - it's a
                                    simple, free home for independent movie and TV reviews, just without
                                    all the ads and privacy invasion stuff you see on other sites.
                                    <br/><br/>
                                    There's no monetisation of content - so there is no incentive for click-bait headlines
                                    or content. We're hoping it can become a place folks can read interesting content
                                    in a nice environment.
                                </p>
                                <br/>
                                <h1 className="darkGrey">no ads or monetisation at all?</h1>
                                <p className="aboutBlurb"> zero.
                                </p>
                                <br/>
                                <h1 className="darkGrey">how do you pay for the run costs?</h1>
                                <p className="aboutBlurb"> The site is 'serverless' - built and hosted in a low-cost fashion
                                    on a cloud platform. If for some reason the site gets really popular we may need
                                    to look for help paying for it, but we'll cross that bridge when we get to it.
                                </p>
                                <br/>
                                <h1 className="darkGrey">what content will you have?</h1>
                                <p className="aboutBlurb"> Independent movie and TV reviews, features and interviews.
                                    We want NOadsHERE to be a thoughtful, trustworthy place for people who love film and
                                    television, with an editorial voice that is never shaped by advertisers, affiliates or
                                    tracking data.
                                </p>
                                <br/>
                                <h1 className="darkGrey">why aren't there any user accounts?</h1>
                                <p className="aboutBlurb"> We don't want any user tracking at all - so users of this site can know
                                    there's no data about their visits being stored anywhere.
                                </p>
                                <br/>
                                <h1 className="darkGrey">how will you know if you have any visitors?</h1>
                                <p className="aboutBlurb"> We're going to try assess user visitors from backend logs - i.e. how much
                                    network traffic to the site have we been getting.
                                </p>
                                <br/>
                                <h1 className="darkGrey">who runs the site?</h1>
                                <p className="aboutBlurb">I'm Andy O'Sullivan, innovation engineer for Liberty IT, and independent game-developer.
                                    I won't be promoting my games on this site however ... as there's no ads! Even for me!
                                </p>
                                    <br/>

                                    <h1 className="darkGrey">contact details?</h1>
                                    <p className="aboutBlurb">You can connect with
                                    me at <a href="https://bsky.app/profile/andyosullivan.bsky.social" target="_blank" rel="noreferrer">Bluesky </a>
                                    or <a href="https://www.linkedin.com/in/andy-o-sullivan-9673019/" target="_blank" rel="noreferrer" >LinkedIn </a>
                                    or you can email me at <a className="links" href="mailto:andy@noadshere.com">andy@noadshere.com</a>.
                                    <br/><br/>
                                    We also have a <a href="https://bsky.app/profile/noadshere.com" target="_blank" rel="noreferrer"> Bluesky account </a>
                                    for the site if you want to follow or share.
                                </p>
                                <br/>

                                <h1 className="darkGrey">why aren't there any capital letters at the start of these questions?!</h1>
                                <p className="aboutBlurb"> we're beginning to ask ourselves that aswell.
                                </p>
                                <br/>
                                <a href="/"> <img className="logo" src={logo} alt="noadshere.com text logo"/></a>
                            </div>
                        </Col>
                        <Col className="" sm={12} lg={4}>
                            <div className="wotDiv">
                                <a href="/"> <img className="logo logo2" src={logo} alt="noadshere.com text logo"/></a>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="footerAbout">
                    <a className="footerLinks" href="/">home</a>
                    <a className="footerLinks" href="/tv/all">tv</a>
                    <a className="footerLinks" href="/movies/all">movies</a>
                    <a className="footerLinks" href="/about/">about</a>
                </div>
            </div>
        );
    }
}

/*


 Home

 About

 Movie Reviews

 App Development

 Serverless ?

 */
